import moment from 'moment';
import React, { useEffect, useRef } from 'react';
import urlparam from 'urlparam';
import { DATE_FORMAT_URL, DATE_ISO_FORMAT, DATE_LONG_FORMAT_WITH_DAYOFWEEK, DATE_LONG_FORMAT_WITH_YEAR_AND_DAYOFWEEK } from '../../../../../../../data/constants/datetime';
import { eventMomentFactory } from '../../../../../../../data/misc/eventMomentFactory';
import styles from './DateMeetings.module.scss';
import ListItemMeeting from './ListItemMeeting';
import { formatDate } from '../../../../../../../data/misc/formatDate';

function DateMeetings(props) {
    const { date, event, meetings } = props,
        ref = useRef(),
        focusDate = urlparam('date');

    useEffect(() => {
        if (!focusDate) return;

        const focusSelf = date == moment(focusDate, DATE_FORMAT_URL).format(DATE_ISO_FORMAT);
        if (!focusSelf) return;

        if (!ref.current) return;
        ref.current.scrollIntoView({ behavior: 'smooth' });
    }, [focusDate]);

    if (!meetings.length) return null;

    return (
        <div ref={ref}>
            <h2 className={styles.dateHeader}>{formatDate(eventMomentFactory(event, date, DATE_ISO_FORMAT), DATE_LONG_FORMAT_WITH_DAYOFWEEK, DATE_LONG_FORMAT_WITH_YEAR_AND_DAYOFWEEK)}</h2>
            <ul className="list">
                {meetings.map((meeting) => (
                    <ListItemMeeting key={meeting.id} event={event} meeting={meeting} />
                ))}
            </ul>
        </div>
    );
}

export default DateMeetings;
